import { useCallback } from "react";
import api from "../services/api";

// Small helper hook to centralize chat list fetching and tag filtering
export function useChats(user) {
  const tokenHeader = { headers: { Authorization: "Bearer " + user?.token } };

  const fetchAllChats = useCallback(async () => {
    // Initializes pagination cache and fetches the first page used by the app
    localStorage.setItem("chats", 2);
    const response = await api.get(`/chats/admin/${localStorage.getItem("chats")}`, tokenHeader);
    return response.data;
  }, [user?.token]);

  const updateAllChats = useCallback(async (selectedTags = []) => {
    // If filtering by tags, defer to tag fetcher
    if (Array.isArray(selectedTags) && selectedTags.length > 0) {
      return await fetchByTags(selectedTags);
    }

    if (localStorage.getItem("chats")) {
      let chatsNumber = Number(localStorage.getItem("chats")) || 2;
      chatsNumber += 1;
      localStorage.setItem("chats", chatsNumber);
    } else {
      localStorage.setItem("chats", 2);
    }

    const response = await api.get(`/chats/admin/${localStorage.getItem("chats")}`, tokenHeader);
    return response.data;
  }, [user?.token]);

  const fetchByTags = useCallback(async (tags = [], options = {}) => {
    if (!Array.isArray(tags) || tags.length === 0) return [];
    const query = tags.join(",");
    const params = new URLSearchParams({ tags_id: query });

    if (options.scope) params.set("scope", options.scope);
    if (options.adminId) params.set("admin_id", options.adminId);
    if (options.page) params.set("page", options.page);
    if (options.limit) params.set("limit", options.limit);

    const response = await api.get(`/chats/tags?${params.toString()}`, tokenHeader);
    return response.data;
  }, [user?.token]);

  const clearLocalCache = useCallback(() => {
    // Clear numeric keys and chat helpers from localStorage
    const keys = Object.keys(localStorage);
    keys.forEach(k => {
      if (!isNaN(k)) localStorage.removeItem(k);
    });
    if (localStorage.getItem("open_chat")) localStorage.removeItem("open_chat");
    if (localStorage.getItem("chats")) localStorage.removeItem("chats");
  }, []);

  return { fetchAllChats, updateAllChats, fetchByTags, clearLocalCache };
}
